import styled from 'styled-components';

export const ContainerError = styled('div')`
  display: flex;
  align-items: center;
  height: calc(100vh - 48px);

  .img-container {
    text-align: right;
    padding-right: 40px;

    @media (max-width: 720px) {
        text-align: center;
        padding-right: 0;
    
      }
    .img-error {
      height: 50vh;
      width: auto;
      object-fit: contain;

      @media (max-width: 720px) {
        height: 30vh;
      width: auto;
    
      }
    }
  }

  h2{
    @media (max-width: 720px) {
        text-align: center;
        margin-top: 30px;
      }

  }

  p{
    max-width: 70%;
    font-size: 18px;

    @media (max-width: 720px) {
        text-align: center;
        max-width: 80%;
        margin: 0 auto;
      }


     
`;
